import script from "./QMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./QMenuItem.vue?vue&type=script&setup=true&lang=ts"

import "./QMenuItem.vue?vue&type=style&index=0&id=4176bee3&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4176bee3"]])

export default __exports__
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSeparator,QItem,QItemSection,QIcon,QItemLabel,QBadge});qInstall(script, 'directives', {Ripple});
